import React, { useEffect, useState } from 'react'
import { apiGet, apiPost } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import ErrorMessage from 'components/ErrorMessage'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import { preventMaxInput } from 'utils/validations'
import { validationRules } from 'utils/constants'

const SubCategoryAdd = ({ allSubCategory, handleCategory, setPage }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [categoryList, setCategoryList] = useState([])
  const [cat, setCat] = useState('')
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })
  const [addMerchantLoading, setAddMerchantLoading] = useState(false)

  const onSubmit = async data => {
    setAddMerchantLoading(true)
    try {
      const payload = {
        categoryId: cat,
        name: data?.name?.trim()
      }
      const res = await apiPost(apiPath.subcategoryAdd, payload)
      if (res?.data?.success) {
        allSubCategory()
        setPage(1)
        handleCategory(false)
        notification.success(res?.data?.message)
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setAddMerchantLoading(false)
    }
  }

  const allCategory = async payload => {
    try {
      var path = apiPath.categoryAllList
      const result = await apiGet(path, payload)
      if (result?.data?.success) {
        var response = result?.data?.results?.allCategories
        setCategoryList(response)
      }
    } catch (error) {
      console.log('error in get all subcategory list==>>>>', error.message)
    }
  }

  const selectCategory = e => {
    if (e.target.value) {
      setCat(e.target.value)
      clearErrors('categoryId')
    } else {
      setCat('')
      setError('categoryId', {
        type: 'validation',
        message: 'Please select category.'
      })
    }
  }

  useEffect(() => {
    allCategory()
  }, [])

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='border-b border-solid border-slate-200 rounded-t flex items-center justify-between p-5 '>
                <h3 className='font-semibold text-xl '>
                  {t('SUBCATEGORY_ADD')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center leading-none font-extralight text-black border-2 rounded-full  h-8 w-8 float-right text-3xl  outline-none focus:outline-none'
                  title='Close'
                  onClick={() => handleCategory(false)}
                >
                  <span title='Close' className='text-4xl text-[#B8BBBF]'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0  w-full group'>
                      <select
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        type='select'
                        id='categoryId'
                        value={cat}
                        {...register('categoryId', {
                          required: 'Please select category name.'
                        })}
                        onChange={selectCategory}
                      >
                        <option value=''>{t('OFFERS_SELECT_CATEGORY')}</option>
                        {categoryList &&
                          categoryList?.map(item => {
                            return (
                              <option value={item?._id}>{item?.name}</option>
                            )
                          })}
                      </select>
                      <label
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                        htmlFor='categoryId'
                      >
                        {' '}
                        {t('OFFERS_CATEGORY')}
                        <span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.categoryId?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <OInputField
                      wrapperClassName='relative z-0 w-full group'
                      name='name'
                      id='name'
                      type='text'
                      inputLabel={
                        <>
                          {t('SUB_CATEGORY_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      placeholder=''
                      maxLength={200}
                      onInput={e => preventMaxInput(e, 200)}
                      register={register('name', {
                        required: 'Please enter subcategory name.',
                        minLength: {
                          value: 2,
                          message: 'Minimum length must be 2.'
                        },
                        pattern: {
                          value: validationRules.characters,
                          message: validationRules.charactersMessage
                        }
                      })}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => handleCategory(false)}
                >
                  {t('O_BACK')}
                </button>
                {addMerchantLoading ? (
                  <button className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
                    <div className='spinner-container'>
                      <div className='loading-spinner'></div>
                    </div>
                  </button>
                ) : (
                  <button
                    className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                    type='submit'
                    onClick={handleSubmit(onSubmit)}
                  >
                    {t('O_ADD')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SubCategoryAdd
